import RouletteNavbar from "./Roulette/RouletteNavbar";
import RouletteMain from "./Roulette/RouletteMain";

const Roulette = () => {
  return (
    <>
      <div className="RouletteNavbar">
        <RouletteNavbar />
      </div>
      <div className="RouletteMain">
        <RouletteMain />
      </div>
    </>
  )
}
export default Roulette
